import { render, staticRenderFns } from "./PackageList.vue?vue&type=template&id=239478b4&scoped=true"
import script from "./PackageList.vue?vue&type=script&lang=js"
export * from "./PackageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239478b4",
  null
  
)

export default component.exports